import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Wordmark } from '../Landing';
import { ApiError, type AuthTokens, api, setSession } from '../api';
import { PasswordInput } from '../components/ui/Input';
import { type Lang, setLang, t } from '../i18n';

export function OwnerLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const res = await api<{
        tokens: AuthTokens;
        user: { preferred_lang: Lang };
      }>('/v1/auth/owner/signin', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      setSession(res.tokens, 'owner');
      setLang(res.user.preferred_lang);
      nav('/home');
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : t('Failed'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-lg border border-border bg-white p-6 shadow-elev-3 sm:p-8 space-y-4"
      >
        <Wordmark className="mb-7" />
        <input
          className="input"
          type="email"
          dir="ltr"
          placeholder={t('Email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          // biome-ignore lint/a11y/noAutofocus: owner sign-in is a dedicated full-screen route and this is its first field; opening ready to type is the intended mobile-first flow
          autoFocus
          autoComplete="email"
          required
        />
        <PasswordInput
          placeholder={t('Password')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        {err && <div className="text-danger text-sm">{err}</div>}
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? '…' : t('Sign in')}
        </button>
        <div className="text-center text-sm text-muted-foreground">
          {t('New?')}{' '}
          <Link to="/signup" className="text-primary underline">
            {t('Start a new household')}
          </Link>
        </div>
      </form>
    </div>
  );
}
